var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComplex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Property / Complex") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Property-/-Complex",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Community-Line",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,20.9999979 L2.99999995,20.9999979 L2.99999995,20.9999979 C2.44771496,20.9999979 1.99999995,20.552285 1.99999995,19.9999979 C1.99999995,19.9999979 1.99999995,19.9999979 1.99999995,19.9999979 L1.99999995,12.487 L1.99999995,12.4868907 C1.99999995,12.1977927 2.12511295,11.9228417 2.34308195,11.7329277 L5.99999995,8.54399773 L5.99999995,3.99999788 L5.99999995,3.99999788 C5.99999995,3.44771288 6.44771695,2.99999788 6.99999995,2.99999788 L21,2.99999788 L21,2.99999788 C21.5522869,2.99999788 22,3.44771288 22,3.99999788 L22,19.9999979 L22,19.9999979 C22,20.5522829 21.5522869,20.9999979 21,20.9999979 L21,20.9999979 Z M9,19 L12,19 L12,12.942 L8,9.454 L4,12.942 L4,19 L7,19 L7,15 L9,15 L9,19 Z M14,19 L20,19 L20,5 L8,5 L8,7.127 C8.234,7.127 8.469,7.209 8.657,7.374 L13.657,11.733 L13.657,11.733 C13.874948,11.922937 14.000032,12.197902 14,12.487 L14,19 L14,19 Z M16,11 L18,11 L18,13 L16,13 L16,11 Z M16,15 L18,15 L18,17 L16,17 L16,15 Z M16,7 L18,7 L18,9 L16,9 L16,7 Z M12,7 L14,7 L14,9 L12,9 L12,7 Z",
    id: "Shape",
    fillOpacity: 0.64,
    fill: "#191923",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplex);
export default __webpack_public_path__ + "static/media/Complex.325ed12b1145f7f20e8af2aab9578e23.svg";
export { ForwardRef as ReactComponent };